import React from 'react';

export class ProductDetailForm extends React.Component {
  constructor(props) {
    super(props);
    this.attemptToAddToBag = this.attemptToAddToBag.bind(this);
  }

  generateFieldTwo() {
    var returnString = '';
    if (this.props.currentAttributeState != undefined) {
      Object.values(this.props.currentAttributeState).map((x) => {
        if (this.props.currentAttributeState[x.attrName].selectedValue != 0) {
          if (returnString.length > 0) returnString += '|';
          returnString += x.attrName;
          returnString += ':';
          returnString += x.selectedValue;
        }
        // console.log(returnString)
      });
    }

    return returnString;
  }
  attemptToAddToBag(event) {
    this.props.passedFunctions.ajaxAddToBag();
    event.preventDefault();
    return false;
  }

  render() {
    return (
      <form
        id='ProductForm'
        className={`productDisplay__form 
			${
        (this.props.contentData.productLayout != undefined &&
          this.props.contentData.productLayout == 'ProductItemDisplayChanel') ||
        (this.props.contentData.productLayout != undefined &&
          this.props.contentData.productLayout == 'ProductItemAttrDisplay') ||
        (this.props.contentData.productLayout != undefined &&
          this.props.contentData.productLayout == 'ProductItemDisplay')
          ? 'row m-0'
          : ''
      }`}
        action='/webapp/wcs/stores/servlet/OrderItemAdd?ak=n'
        method='post'
        data-catentry={this.props.contentData.productId || ''}
        onSubmit={this.attemptToAddToBag}
      >
        <input type='hidden' name='storeId' value='301' />
        <input type='hidden' name='orderId' value='.' />
        <input type='hidden' name='catalogId' value='301' />
        <input type='hidden' name='langId' value='-1' />
        <input type='hidden' name='errorViewName' value='ProductDisplayView' />
        <input type='hidden' name='URL' value='ProductDisplayView' />
        <input type='hidden' name='rURL' value='ProductDisplayView' />
        <input type='hidden' name='catEntryId' value={this.props.contentData.productId} />
        <input type='hidden' name='productId' value={this.props.contentData.productId} />
        <input
          type='hidden'
          name='limitedAvailability'
          value={this.props.contentData.limitedAvailability ? 'Y' : 'N'}
        />
        <input
          type='hidden'
          name='description'
          value={`${this.props.contentData.partNumber}|${this.props.contentData.productId}|PP-PIP`}
        />
        <input type='hidden' name='field2' value={this.generateFieldTwo()} />
        <input type='hidden' name='field3' value={this.generateFieldTwo()} />
        <input
          type='hidden'
          name='subscriptionFrequency'
          value={this.props.passedFunctions.parentState.subscriptionFrequency}
        />
        {this.props.children}
      </form>
    );
  }
}

export default ProductDetailForm;
